import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import { composeMapper } from '@wix/editor-elements-preview-utils';
import { PreviewWrapperProps } from '@wix/editor-elements-types';
import {
  WRichTextDefinition,
  WRichTextProps,
} from '@wix/thunderbolt-components';
import { props as viewerPropsMapper } from './WRichText.mapper';

const props = composeMapper<
  PreviewWrapperProps<WRichTextProps>,
  WRichTextDefinition,
  WRichTextProps
>()(
  viewerPropsMapper,
  { add: ['compPreviewState'] },
  (resolver, dependencies, carmiData) => {
    const viewerProps = resolver(dependencies, carmiData);
    const { compPreviewState } = dependencies;
    // Using `carmiData` inside the previewMapper is discouraged in general and will be removed once
    // this refactor ticket is complete - https://jira.wixpress.com/browse/ECL-1863
    const { html } = carmiData;
    return {
      ...viewerProps,
      html,
      previewWrapperProps: { compPreviewState },
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
});
